module.exports = __webpack_public_path__ + "static/media/glass_door_3d.89c897ae.jpg";